export {BaseScope} from './base';
export {AutoScope} from './auto';
export {ArrayScope} from './array';
export {AsyncScope} from './async';
export {CastScope} from './cast';
export {FullScope} from './full';
export {ObjectScope} from './object';
export {ProxyScope} from './proxy';



// WEBPACK FOOTER //
// ../hyper-value/src/scopes/index.ts